import { Component, OnInit, Input } from '@angular/core';
import { FormGroupDirective, FormGroup, FormControl, ControlContainer, Validators } from '@angular/forms';
import { Address } from '../../models/address.model';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-address-form',
  templateUrl: './address-form.component.html',
  styleUrls: ['./address-form.component.css'],
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AddressFormComponent implements OnInit {
  private _address: Address;

  @Input()
  disabled: boolean = false;

  constructor(
    public parent: FormGroupDirective,
    public translateService: TranslateService
  ) { }

  ngOnInit() {
    this.parent.form.addControl('address', new FormGroup({
      street: new FormControl('', Validators.required),
      town: new FormControl('', Validators.required),
      zipcode: new FormControl('', [Validators.required, Validators.minLength(5)]),
      country: new FormControl('CZ', Validators.required)
    }));

    if (this._address) {
      this.parent.form.patchValue({
        address: {
          street: this._address.street,
          town: this._address.town,
          zipcode: this._address.zipCode,
          country: this._address.country
        }
      });
    }

    if (this.disabled) {
      this.parent.form.get('address').disable();
    }
  }

  @Input()
  set address(address: Address) {
    this._address = address;
  }

}
